import {
	mapActions,
	mapGetters
} from 'vuex';

import {
	EventBus
} from '@/support/event-bus';

import {
	Upload,
	Card
} from 'element-ui';

import {
	cloneDeep,
	includes,
	filter
} from 'lodash';

import PageBar from '@/components/page-bar/page-bar';
import Students from '@/domains/student/students';
import ClassList from '@/domains/school/class-list/main';

import toastr from '@/support/toastr';

export default {
	name: 'album',
	components: {
		PageBar,
		Students,
		Upload,
		Card,
		ClassList
	},
	data: () => ({
		showAssingVisible: false,
		viewersGalleryType: '',
		dataUpload: {
			title: '',
			description: '',
			id: ''
		},
		isEdit: false,
		assingPhotos: [],
		checkPhoto: []
	}),
	computed: {
		...mapGetters([
			'album',
			'getLoggedUser',
			'ENUM',
			'getClass',
			'getStudent'
		])
	},
	methods: {
		...mapActions([
			'setBreadcrumb',
			'setAlbum',
			'newAlbum',
			'unpublishAlbum',
			'setUpload',
			'unpublishPhotos',
			'publishPhotos',
			'publishAlbum',
			'setInfoPhoto',
			'editAlbum',
			'removePhoto',
			'putAssignPhotoUsers',
			'cleanAlbum'
		]),
		selectPhotos(event, photo) {

			if (event.target.checked) {
				this.assingPhotos.push(photo);
			} else {
				this.assingPhotos = filter(this.assingPhotos, function(n) {
					return n.id !== photo.id;
				});
			}
		},
		unselectAllPhotos() {
			this.assingPhotos = [];
		},
		selectAllPhotos() {

			this.assingPhotos = cloneDeep(this.album.photos);
		},
		deletePhoto(id) {
			this.removePhoto({
				id: id,
				userId: this.getLoggedUser.id
			}).then(() => {
				toastr.success(this.$gettext('Foto excluída com sucesso!'));
				this.setAlbum({
					userId: this.getLoggedUser.id,
					id: this.$route.params.id
				});
			});
		},
		isChecked(id) {

			let photosId = [];

			this.assingPhotos.forEach(function(value) {
				photosId.push(value.id);
			});

			return includes(photosId, id);

		},
		changeInfoPhoto(id, title, description) {

			this.setInfoPhoto({
				id: id,
				infoPhoto: {
					title: title,
					description: description
				},
				userId: this.getLoggedUser.id
			});

		},
		getStatusLabelColor(status) {

			const redClass = 'bg-red-flamingo bg-font-red-flamingo';
			const yellowClass = 'bg-yellow-lemon bg-font-yellow-lemon';
			const grayClass = 'bg-grey-salsa bg-font-grey-salsa';
			const greenClass = 'bg-green-jungle bg-font-green-jungle';

			return {
				'NOT_CREATED': redClass,
				'CREATED': yellowClass,
				'IN_APPROVAL': yellowClass,
				'IN_REVISION': redClass,
				'PROCESSING': grayClass,
				'REPROCESS': yellowClass,
				'APPROVED': greenClass,
				'SENT': greenClass,
				'READED': greenClass
			}[status];

		},
		unpublishPhotoItem() {

			let photos = [];

			this.assingPhotos.forEach(function(value) {
				photos.push(value.id);
			});

			this.unpublishPhotos({
				id: this.$route.params.id,
				userId: this.getLoggedUser.id,
				photos: photos
			}).then(() => {
				toastr.success(this.$gettext('Fotos despublicadas com sucesso!'));
				this.setAlbum({
					userId: this.getLoggedUser.id,
					id: this.$route.params.id
				});
			});

		},
		publishPhotoItem() {
			let photos = [];

			this.assingPhotos.forEach(function(value) {
				photos.push(value.id);
			});

			this.publishPhotos({
				id: this.$route.params.id,
				userId: this.getLoggedUser.id,
				photos: photos
			}).then(() => {
				toastr.success(this.$gettext('Fotos publicadas com sucesso!'));
				this.setAlbum({
					userId: this.getLoggedUser.id,
					id: this.$route.params.id
				});
			});
		},
		dataUploadStringify() {
			return {
				album: JSON.stringify(this.dataUpload)
			};
		},
		createAlbum() {

			if (this.isEdit === false) {

				if (this.viewersGalleryType == 'SCHOOL_CLASS') {

					this.newAlbum({
						userId: this.getLoggedUser.id,
						album: this.dataUpload,
						schoolClass: this.getClass,
						scope: 'SCHOOL_CLASS'
					}).then((response) => {
						this.dataUpload.id = response.id;
						this.$route.params.id = response.id;
						this.isEdit = true;
						toastr.success(this.$gettext('Álbum criado com sucesso!'));
					});

				} else if (this.viewersGalleryType == 'STUDENT') {

					this.newAlbum({
						userId: this.getLoggedUser.id,
						album: this.dataUpload,
						students: this.getStudent,
						scope: 'STUDENT'
					}).then((response) => {
						this.dataUpload.id = response.id;
						this.$route.params.id = response.id;
						this.isEdit = true;
						toastr.success(this.$gettext('Álbum criado com sucesso!'));
					});

				} else {

					this.newAlbum({
						userId: this.getLoggedUser.id,
						album: this.dataUpload,
						scope: 'ALL'
					}).then((response) => {
						this.dataUpload.id = response.id;
						this.$route.params.id = response.id;
						this.isEdit = true;
						toastr.success(this.$gettext('Álbum criado com sucesso!'));
					});
				}
			} else {

				if (this.viewersGalleryType == 'SCHOOL_CLASS') {

					this.editAlbum({
						userId: this.getLoggedUser.id,
						album: this.dataUpload,
						schoolClass: this.getClass,
						scope: 'SCHOOL_CLASS'
					}).then(() => {
						toastr.success(this.$gettext('Álbum editado com sucesso!'));
					});

				} else if (this.viewersGalleryType == 'STUDENT') {

					this.editAlbum({
						userId: this.getLoggedUser.id,
						album: this.dataUpload,
						schoolClass: this.getStudent,
						scope: 'STUDENT'
					}).then(() => {
						toastr.success(this.$gettext('Álbum editado com sucesso!'));
					});

				} else {
					this.editAlbum({
						userId: this.getLoggedUser.id,
						album: this.dataUpload,
						scope: 'ALL'
					}).then(() => {
						toastr.success(this.$gettext('Álbum editado com sucesso!'));
					});
				}
			}
		},
		upload(response) {
			this.setUpload(response).then(() => {
				this.album;
			});
		},
		publish(id) {

			this.publishAlbum({
				id: id,
				userId: this.getLoggedUser.id,
			}).then(() => {
				toastr.success(this.$gettext('Álbum publicado com sucesso!'));

			});

		},
		unpublish(id) {

			this.unpublishAlbum({
				id: id,
				userId: this.getLoggedUser.id,
			}).then(() => {
				toastr.success(this.$gettext('Álbum despublicado com sucesso!'));
			});

		},
	},
	created() {

		if (this.$route.params.id) {
			this.isEdit = true;
		}

		if (this.$route.params.id === undefined) {
			this.$route.params.id = '';
		}

		if (this.isEdit) {

			this.setAlbum({
				userId: this.getLoggedUser.id,
				id: this.$route.params.id
			}).then(() => {

				if (this.isEdit) {
					this.viewersGalleryType = this.album.scope;
					this.classList = this.album.schoolClasses;
					this.student = this.album.students;
					this.dataUpload = {
						id: this.$route.params.id,
						title: this.album.title,
						description: this.album.description,
					};
				} else {
					this.dataUpload = {
						id: '',
						title: '',
						description: ''
					};
				}
			});
		}

	},
	beforeDestroy() {
		this.$route.params.id = '';
		EventBus.$off('showAssing');

		this.cleanAlbum();
	},
	mounted() {

		this.setBreadcrumb([{
			text: 'Administrativo'
		}, {
			text: 'Galeria'
		}, {
			text: 'Álbum'
		}]);

	}
};


// WEBPACK FOOTER //
// ./sources/app/gallery/album/index.js